'use strict'

angular
  .module('basalteApp')
  .constant('BAS_MAIN', {
    EVT_MAIN_SWIPE_UP: 'evtBasMainSwipeUp',
    EVT_MAIN_SWIPE_DOWN: 'evtBasMain SwipeDown'
  })
